export default {
  recharge: '/courier/api/financial/recharge'
}
